'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _LocPresentational = require('./LocPresentational');
var _LocPresentational2 = _interopRequireDefault(_LocPresentational);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// The component expects that reducer will be named as i18n
var mapStateToProps = function mapStateToProps(_ref, ownProps) {
  var _ref$i18n = _ref.i18n,
    currentLanguage = _ref$i18n.currentLanguage,
    dictionaries = _ref$i18n.dictionaries;
  return {
    currentLanguage: currentLanguage,
    dictionary: dictionaries[currentLanguage]
  };
};

// Import presentational component
exports.default = (0, _reactRedux.connect)(mapStateToProps)(_LocPresentational2.default);